<template>
    <div id="student-triage-form">
        <form id="triageForm">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="studentNumber" class="font-weight-bold">Student Number</label>
                        <input v-model="studentNumber" type="number"
                            :class="studentNumberValid == true ? 'form-control' : 'form-control is-invalid'"
                            id="studentNumber" placeholder="Ex. 250123456">
                        <div v-if="!studentNumberValid" class="invalid-feedback">
                            Please provide a valid student number.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="mail" class="font-weight-bold">Email address</label>
                        <input v-model="mail" type="email"
                            :class="mailValid == true ? 'form-control' : 'form-control is-invalid'" id="mail"
                            placeholder="Ex. jsmith123@uwo.ca">
                        <div v-if="!mailValid" class="invalid-feedback">
                            Please provide a valid email.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="firstName" class="font-weight-bold">First Name</label>
                        <input v-model="firstName" type="text"
                            :class="firstNameValid == true ? 'form-control' : 'form-control is-invalid'" id="firstName"
                            placeholder="Ex. John">
                        <div v-if="!firstNameValid" class="invalid-feedback">
                            Please provide a valid first name.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="lastName" class="font-weight-bold">Last Name</label>
                        <input v-model="lastName" type="text"
                            :class="lastNameValid == true ? 'form-control' : 'form-control is-invalid'" id="lastName"
                            placeholder="Ex. Smith">
                        <div v-if="!lastNameValid" class="invalid-feedback">
                            Please provide a valid last name.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="preferredName" class="font-weight-bold">Preferred Name</label>
                        <input v-model="preferredName" type="text" id="preferredName" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="mail" class="font-weight-bold">Home Faculty</label>
                        <select v-model="homeFaculty" class="form-control" id="homeFaculty">
                            <option value="Kings">King's</option>
                            <option>Western</option>
                            <option>Brescia</option>
                            <option>Huron</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="degree" class="font-weight-bold">Degree</label>
                        <select v-model="degree" class="form-control" id="degree">
                            <option>Bachelor of Arts</option>
                            <option>Bachelor of Management and Organizational Studies</option>
                            <option>Bachelor of Social Work</option>
                            <option>Second Degree</option>
                            <option>Special Student</option>
                            <option>Not Available</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="yearOfStudy" class="font-weight-bold">Year of Study</label>
                        <select v-model="yearOfStudy" class="form-control" id="yearOfStudy">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>Not Available</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="currentModuleCombination" class="font-weight-bold">Current Module
                            Combination</label>
                        <textarea v-model="currentModuleCombination"
                            :class="currentModuleCombinationValid == true ? 'form-control' : 'form-control is-invalid'"
                            id="currentModuleCombination" rows="3"
                            placeholder="Ex. Major in Sociology, HSP in Psychology, Double Major in History and Political Science"></textarea>
                        <div v-if="!currentModuleCombinationValid" class="invalid-feedback">
                            Please provide a current module combination.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="desiredModuleCombination" class="font-weight-bold">Desired Module
                            Combination</label>
                        <textarea v-model="desiredModuleCombination"
                            :class="desiredModuleCombinationValid == true ? 'form-control' : 'form-control is-invalid'"
                            id="desiredModuleCombination" rows="3"
                            placeholder="Note: Specify what program you’d like to be in, if it’s different than the program that you are currently in"></textarea>
                        <div v-if="!desiredModuleCombinationValid" class="invalid-feedback">
                            Please provide a desired module combination.
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="primaryConcerns" class="font-weight-bold">What are your primary concerns?</label>
                        <div v-if="!primaryConcernsValid" class="mb-2 text-danger">
                            Please select at least one concern.
                        </div>
                        <h6>Please check all that apply:</h6>
                        <div v-for="(concerns, index) in primaryConcernsOptions" :key="index" class="input-group mb-2">
                            <label :for="`primaryConcerns`+index" style="display: flex; flex-direction: row; align-items: center;">
                                <input type="checkbox" v-model="primaryConcerns[index][index]" :id="`primaryConcerns`+index" :value="concerns" style="vertical-align: middle; position: relative;">
                                &nbsp;{{ concerns }}&nbsp;
                            </label>
                            <input type="text" style="vertical-align: middle; position: relative;" name="otherconern" v-if="index == 5 && primaryConcerns[index][index] == true" v-model="otherConcern" :class="otherConcernValid == true ? 'form-control' : 'form-control is-invalid'">
                        </div>
                        <div v-if="!otherConcernValid" class="mb-2 text-danger">
                            Please enter your concern
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="questions" class="font-weight-bold">Your Questions</label>
                        <h6>Please be as clear and specific as possible in your
                            questions. Some examples
                            are:</h6>
                        <ul>
                            <li>I don’t have the pre-reqs for Psych 2840F. Can I still take Psych 2840F without the
                                pre-requisites?</li>
                            <li>Can I take a 3000-level course even though I’m in Year 4? I’d like to take CSI 3888F.
                            </li>
                            <li>Can I take a 3000-level course even though I’m in Year 2? I’d like to take CSI 3888F and
                                the
                                only pre-req is the 1st year CSI course and I have taken that 1st year course.</li>
                        </ul>
                        <div v-if="!questionsCountValid" class="mb-2 text-danger">
                            Please provide at least one question.
                        </div>
                        <div class="mb-3">
                            <button type="button" class="btn btn-primary btn-sm" @click="addQuestion">Add
                                Question</button>
                        </div>
                        <div v-if="questions.length == 0" class="alert alert-warning" role="alert">
                            <i class="fas fa-info-circle"></i> You currently have no questions! If you
                            wish to ask a question, please click the "Add Question" button.
                        </div>
                        <div v-for="(question, index) in questions" :key="index" class="input-group mb-2">
                            <input v-model="questions[index].question" type="text"
                                :class="questions[index].valid == true ? 'form-control' : 'form-control is-invalid'"
                                :placeholder="'Question ' + (index + 1)" :aria-label="'Question ' + (index + 1)"
                                aria-describedby="Your Questions">
                            <div class="input-group-append">
                                <button class="btn btn-danger" type="button" @click="removeQuestion(index)"><i
                                        class="fas fa-trash"></i></button>
                            </div>
                            <div v-if="!questions[index].valid" class="invalid-feedback">
                                Please provide a valid question.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="counsellorRequest" class="font-weight-bold">Do you have a specific
                            Advisor/Counsellor that
                            you
                            have worked with previously and would like to see today?</label>
                        <select v-model="counsellorRequest" class="form-control mb-2" id="counsellorRequest">
                            <option>Yes</option>
                            <option>No</option>
                        </select>
                        <label v-if="counsellorRequest == 'Yes'" for="counsellor">Counsellor</label>
                        <select v-if="counsellorRequest == 'Yes'"
                            :class="counsellorValid == true ? 'form-control' : 'form-control is-invalid'"
                            id="counsellor" name="counsellor" v-model="counsellor">
                            <option value="" disabled>Please select a counsellor</option>
                            <option v-for="counsellor in getCounsellors()" :key="counsellor.value"
                                :value="counsellor.value">
                                {{ counsellor.label }}</option>
                        </select>
                        <div v-if="!counsellorValid" class="invalid-feedback">
                            Please provide a advisor/counsellor's name.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="appointmentType" class="font-weight-bold">Appointment Type</label>
                        <select v-model="appointmentType"
                            :class="appointmentTypeValid == true ? 'd-none form-control' : 'd-none form-control is-invalid'"
                            id="appointmentType">
                            <option value="" disabled>Please select..</option>
                            <option value="inperson">In-person</option>
                            <option value="virtual">Virtual</option>
                        </select>
                        <div class="card-subtitle text-muted">
                            Please select:
                        </div>
                        <button
                            v-if="triageSettings.appointmentType == 'all' || triageSettings.appointmentType == 'inperson'"
                            :class="appointmentType == 'inperson' ? 'btn btn-appointment__type btn-appointment__type--active mr-2' : 'btn btn-appointment__type btn-light mr-2'"
                            type="button" @click="setAppointmentType('inperson')">
                            <img class="img-fluid" src="../../../assets/button/ado-inperson.png">
                            In-Person
                        </button>
                        <button
                            v-if="triageSettings.appointmentType == 'all' || triageSettings.appointmentType == 'virtual'"
                            :class="appointmentType == 'virtual' ? 'btn btn-appointment__type btn-appointment__type--active' : 'btn btn-appointment__type btn-light'"
                            type="button" @click="setAppointmentType('virtual')">
                            <img class="img-fluid" src="../../../assets/button/ado-virtual.png">
                            Virtual
                        </button>
                        <div v-if="!appointmentTypeValid" class="invalid-feedback">
                            Please select an appointment type.
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <hr>
        <div v-if="!valid" class="alert alert-warning" role="alert">
            <i class="fas fa-exclamation-circle"></i> The Academic
            Information Counselling Form could not be submitted. Please verify that all required form fields are
            filled in.
        </div>
        <div v-if="error" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-circle"></i> The Academic
            Information Counselling Form could not be submitted. An internal error has occurred. Please contact your
            system
            administrator.
        </div>
        <h6>Many questions about course selection are easy for students to
            address
            by checking program checklists. Please check our FAQ before submitting your questions: <a
                href="https://www.kings.uwo.ca/current-students/courses-enrolment/planning/faq/"
                target="_blank">Academic Advising FAQ page</a></h6>
        <!-- Button trigger modal -->
        <div class="text-right">
            <button v-if="!capacityMet" type="button" class="btn btn-success ml-auto" data-toggle="modal"
                data-target="#submitModal">
                Submit
            </button>
            <button v-else type="button" disabled class="btn btn-secondary ml-auto" data-toggle="modal"
                data-target="#submitModal">
                Submit
            </button>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="submitModal" tabindex="-1" aria-labelledby="submitModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="submitModalLabel">Submit Form</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        Please ensure that you have answered all the questions as required. Please click confirm
                        to proceed.
                    </div>
                    <div class="modal-footer">
                        <button v-if="!submit" type="button" class="btn btn-success"
                            @click="submitForm">Confirm</button>
                        <button v-else type="button" class="btn btn-success" disabled>Submitting <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'student-triage-form',
    props: {
        capacityMet: {
            required: true
        },
        counsellorsData: {
            type: Array
        },
        triageSettings: {
            type: Object
        },
        user: {
            type: Object
        }
    },
    data() {
        return {
            appointmentType: '',
            appointmentTypeValid: true,
            counsellor: '',
            counsellorValid: true,
            counsellorRequest: 'Yes',
            currentModuleCombination: '',
            currentModuleCombinationValid: true,
            degree: 'Bachelor of Arts',
            desiredModuleCombination: '',
            desiredModuleCombinationValid: true,
            error: false,
            firstName: '',
            firstNameValid: true,
            homeFaculty: 'Kings',
            lastName: '',
            lastNameValid: true,
            preferredName: '',
            mail: '',
            mailValid: true,
            questions: [],
            questionsCountValid: true,
            studentNumber: '',
            studentNumberValid: true,
            submit: false,
            valid: true,
            yearOfStudy: '1',
            primaryConcernsOptions: ["Add/dropping classes", "Program check / Course planning", "Academic Considerations - Illness, compassionate, religious, other", "Concerns about a course", "Personal matters", "Other"],
            primaryConcerns: [{0: ''}, {1: ''}, {2: ''}, {3: ''}, {4: ''}, {5: ''}],
            primaryConcernsValid: true,
            otherConcernValid: true,
            otherConcern: ""
        }
    },
    methods: {
        addQuestion() {
            // Add question
            this.questions.push({
                question: '',
                valid: true
            });

            // Validate questions count
            this.questionsCountValid = this.questions && this.questions.length >= 1 ? true : false;
        },
        getCounsellors() {
            let counsellors = [];

            this.counsellorsData.forEach((counsellor) => {
                if (!counsellor.value.match(/GENERAL/gi)) {
                    counsellors.push(counsellor);
                }
            });

            return counsellors;
        },
        removeQuestion(index) {
            // Remove question
            this.questions.splice(index, 1);

            // Validate questions count
            this.questionsCountValid = this.questions && this.questions.length >= 1 ? true : false;
        },
        setAppointmentType(type) {
            this.appointmentType = type;
            console.log(type);
        },
        submitForm() {
            if (this.validateForm()) {
                // TODO: Remove, used for testing
                const that = this;
                const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl?triageSet`;
                const formData = new FormData();

                // Set loader
                this.submit = true;
                this.error = false;

                // Resolve question
                let questions = [];
                this.questions.forEach((question) => {
                    questions.push(question.question)
                });

                // Resolve Pimary Concerns (Updated Dec 2023)
                let primaryConcerns = [];
                for (let index = 0; index < this.primaryConcerns.length; index++) {
                    if(this.primaryConcerns[index][index] != '' && this.primaryConcerns[index][index] == true){
                        if(index == 5){
                            primaryConcerns.push("Other: "+this.otherConcern);
                        }else {
                            primaryConcerns.push(this.primaryConcernsOptions[index]);
                        }
                    }
                }

                // Add form keypair values
                formData.append('data', JSON.stringify({
                    appointmentType: this.appointmentType,
                    counsellor: this.counsellor,
                    counsellorRequest: this.counsellorRequest,
                    currentModuleCombination: this.currentModuleCombination,
                    degree: this.degree,
                    desiredModuleCombination: this.desiredModuleCombination,
                    firstName: this.firstName,
                    homeFaculty: this.homeFaculty,
                    lastName: this.lastName,
                    preferredName: this.preferredName,
                    mail: this.mail,
                    questions: questions,
                    studentNumber: this.studentNumber,
                    username: this.user.username,
                    yearOfStudy: this.yearOfStudy,
                    primaryConcerns: primaryConcerns
                }));
                formData.append('mode', 'triageSet');

                // POST request
                fetch(api, {
                    method: 'POST',
                    body: formData
                }).then(function (response) {
                    // Parse response
                    return response.json();
                }).then(function (json) {
                    // TODO: Remove, used for testing
                    console.log(json);
                    // Store triage data success
                    if (json.result.match(/OK/i)) {
                        // Redirect to dashboard
                        if (json.data) {
                            that.$emit('setTriageData', json.data);
                            that.$emit('setTriageSubmit', true);
                        }
                        that.$emit('setState', 'dashboard');
                    } else {
                        // Set error dialog
                        that.error = true;
                    }

                    // Set loader and close dialog
                    that.submit = false;
                    $('#submitModal').modal('hide');
                }).catch(function (error) {
                    // TODO: Remove, used for testing
                    console.log(error);
                    // Set loader and close dialog
                    that.submit = false;
                    $('#submitModal').modal('hide');

                })
            } else {
                $('#submitModal').modal('hide');
            }
        },
        validateForm() {
            let questionsValid = true;

            // Validate student number
            this.studentNumberValid = this.studentNumber && this.studentNumber.toString().length == 9 ? true : false;

            // Validate first name
            this.firstNameValid = this.firstName && this.firstName.length >= 2 ? true : false;

            // Validate last name
            this.lastNameValid = this.lastName && this.lastName.length >= 2 ? true : false;

            // Validate email
            this.mailValid = this.mail && this.mail.length >= 2 ? true : false;

            // Validate current module combination
            this.currentModuleCombinationValid = this.currentModuleCombination && this.currentModuleCombination.length >= 2 ? true : false;

            // Validate desired module combination
            this.desiredModuleCombinationValid = this.desiredModuleCombination && this.desiredModuleCombination.length >= 2 ? true : false;

            // Validate current module combination
            this.appointmentTypeValid = this.appointmentType != "" ? true : false;

            // Validate Primary Concerns
            let primaryConcerns = [];
            this.otherConcernValid = true;
            for (let index = 0; index < this.primaryConcerns.length; index++) {
                if(this.primaryConcerns[index][index] != '' && this.primaryConcerns[index][index] == true){
                    if(index == 5){
                        if(this.otherConcern == ""){
                            this.otherConcernValid = false;
                        }else {
                            this.otherConcernValid = true;
                            primaryConcerns.push("Other: "+this.otherConcern);
                        }
                    }else {
                        primaryConcerns.push(this.primaryConcernsOptions[index]);
                    }
                }
            }

            this.primaryConcernsValid = primaryConcerns.length >= 1 ? true : false;

            // Validate questions count
            this.questionsCountValid = this.questions && this.questions.length >= 1 ? true : false;

            // Validate questions
            for (let i = 0; i < this.questions.length; i++) {
                this.questions[i].valid = this.questions[i].question ? true : false;

                if (!this.questions[i].valid) {
                    questionsValid = false;
                }
            }

            // Validate counsellor request
            if (this.counsellorRequest == "Yes") {
                this.counsellorValid = this.counsellor && this.counsellor.length >= 2 ? true : false;
            } else {
                this.counsellorValid = true;
            }

            // Validate form
            if (!this.studentNumberValid || !this.firstNameValid || !this.lastNameValid || !this.mailValid || !this.currentModuleCombinationValid || !this.desiredModuleCombinationValid || !this.appointmentTypeValid || !this.questionsCountValid || !questionsValid || !this.counsellorValid || !this.primaryConcernsValid || !this.otherConcernValid) {
                this.valid = false;
            } else {
                this.valid = true;
            }

            return this.valid;
        }
    },
    mounted() {
        // Set default fields
        this.firstName = this.user.name ? this.user.name : this.firstName;
        this.lastName = this.user.surname ? this.user.surname : this.lastName;
        this.mail = this.user.mail ? this.user.mail : this.mail;
        this.studentNumber = this.user.emplid ? this.user.emplid : this.studentNumber;
    }
}
</script>

<style scoped>
.btn-appointment__type {
    max-width: 128px;
    max-height: 130px;
}

.btn-appointment__type--active {
    border-color: #d7ae28;
    color: #d7ae28;
    background: #034638;
}
</style>